import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-select-plain',
  templateUrl: './select-plain.component.html',
  styleUrls: ['./select-plain.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectPlainComponent implements OnInit {
  showOptionsList = false;
  selectedOption;

  @Input() options: Value[] = [];
  @Input() translation: boolean;
  @Input() value: Value;
  @Input() errors;
  @Input() placeholder = 'global.select';
  @Input() iconBaseNameAndUrl: string;
  @Output() valueChange: EventEmitter<Value> = new EventEmitter<Value>();

  constructor() {}

  ngOnInit(): void {
    if (this.value && Object.keys(this.value).length !== 0) {
      this.selectedOption = this.value;
    }
  }

  onValueChange(option, dontEmit?: boolean) {
    !dontEmit ? this.valueChange.emit(option) : null;
    this.selectedOption = option;
    this.showOptionsList = false;
  }

  onClickOutside(event) {
    this.showOptionsList = false;
  }
}

interface Value {
  key: string;
  value: string;
}
